<template>
  <div class="app-wrapper">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss">
@use "~/_colors.scss" as *;
@use "~/_text.scss" as *;

@font-face {
  font-family: "aller-rg";
  src: url("../src/assets/fonts/Aller_Rg.ttf");
}

* {
  padding: 0;
  margin: 0;
  font-family: "aller-rg";
}

html,
body {
  max-width: 100vw;
  max-height: 100vh;
  width: 100vw;
  height: 100vh;
  scroll-behavior: smooth;
}
.app-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  background-image: linear-gradient(
    to bottom,
    darken($primary-color, 2%),
    lighten($primary-color, 5%)
  );
  background-size: 100% 100%;
  background-attachment: fixed;
  overflow: auto;
  overflow-x: hidden;
}
</style>
